<template>
  <span ref="triggerRef" class="intersection-trigger"></span>
</template>
<script>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
export default {
  props: ['root', 'id', 'disconnectOnIntersect'],
  setup(props, { emit }) {
    const triggerRef = ref(null);
    let observer = null;
    const setupObserver = () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      observer = new IntersectionObserver(
          entries => {
            if (entries[0].isIntersecting) {
              emit('intersected', props.id);
              if (props.disconnectOnIntersect) {
                observer.disconnect();
              }
            }
          },
          {
            root: props.root,
            id: props.id,
            threshold: 1,
          }
      );
      observer.observe(triggerRef.value);
    };
    watch(
        () => props.root,
        () => setupObserver()
    );
    onMounted(() => {
      setupObserver();
    });
    onBeforeUnmount(() => {
      observer.disconnect();
    });
    return {
      triggerRef,
    };
  },
};
</script>